import { ContentProviderProviders } from '@/__generated__/gql/graphql'
import { Result } from '@/services/yi/Result'
import { ContentType, YI_CONTENT_TYPE_TAG } from './types'

type Details = {
  contentProvider?: {
    provider?: ContentProviderProviders | null
  } | null
  contentType?: string | null
  yiContentTypeTag?: {
    title?: string | null
  } | null
}
/**
 * At first it was planned to create content pages for both YI and Gaia. But then it was decided to create dedicated content pages for YI due to lack of time to update content pages for Gaia. The original purpose of creating this function was to provide the following
 * 1. isolated logic to determine content type based on content form and some implicit attributes (such as specific tags, content type, etc.)
 * 2. some yi content types are represented by multiple content groups (e.g. yi “Course Type” - Challenge, Podcast, Workshop, Premium Training)
 */
export function getYIContentType (content?: Details | null) {
  const provider = content?.contentProvider?.provider ?? null

  if (provider === ContentProviderProviders.YogaInternational) {
    const yiContentType = content?.yiContentTypeTag?.title
    switch (yiContentType) {
      case YI_CONTENT_TYPE_TAG.CLASS: {
        return Result.ok(ContentType.YI_CLASS)
      }
      case YI_CONTENT_TYPE_TAG.MEDITATION: {
        return Result.ok(ContentType.YI_MEDITATION)
      }
      case YI_CONTENT_TYPE_TAG.PREMIUM_TRAINING: {
        return Result.ok(ContentType.YI_COURSE)
      }
      case YI_CONTENT_TYPE_TAG.CHALLENGE: {
        return Result.ok(ContentType.YI_COURSE)
      }
      case YI_CONTENT_TYPE_TAG.PODCAST: {
        return Result.ok(ContentType.YI_COURSE)
      }
      case YI_CONTENT_TYPE_TAG.WORKSHOP: {
        return Result.ok(ContentType.YI_COURSE)
      }
      case YI_CONTENT_TYPE_TAG.POSE: {
        return Result.ok(ContentType.YI_POSE)
      }
      case YI_CONTENT_TYPE_TAG.ARTICLE: {
        return Result.ok(ContentType.YI_ARTICLE)
      }
      case YI_CONTENT_TYPE_TAG.COURSE_SALES_PAGE: {
        return Result.ok(ContentType.YI_COURSE_SALES)
      }
      case YI_CONTENT_TYPE_TAG.MEMBER_PROMO: {
        return Result.ok(ContentType.YI_MEMBERSHIP_PROMO)
      }
      case YI_CONTENT_TYPE_TAG.HOMEPAGE_HERO: {
        return Result.ok(ContentType.YI_HOMEPAGE_HERO)
      }
      case YI_CONTENT_TYPE_TAG.SERIES: {
        return Result.ok(ContentType.YI_SERIES)
      }
      case YI_CONTENT_TYPE_TAG.SERIES_EPISODE: {
        return Result.ok(ContentType.YI_SERIES_EPISODE)
      }
      case YI_CONTENT_TYPE_TAG.TEACHER: {
        return Result.ok(ContentType.YI_TEACHER)
      }
      case YI_CONTENT_TYPE_TAG.TAG: {
        return Result.ok(ContentType.YI_TAG)
      }
      case YI_CONTENT_TYPE_TAG.TAG_GROUP: {
        return Result.ok(ContentType.YI_TAG_GROUP)
      }
      case YI_CONTENT_TYPE_TAG.COURSE_MODULE_GROUP: {
        return Result.ok(ContentType.YI_COURSE_SECTION)
      }
      case YI_CONTENT_TYPE_TAG.COURSE_MODULE: {
        return Result.ok(ContentType.YI_COURSE_MODULE)
      }
      default: {
        return Result.fail('Group of the content is YI, but the type is unknown')
      }
    }
  }

  // NOTE: Gaia content is out of scope
  // if (provider === null && contentType === 'video') {
  //   return Result.ok(ContentType.GAIA_VIDEO)
  // }
  return Result.fail('unknown content type')
}
